import React, { useContext } from 'react'
import { ButtonContent } from '../global/boton/ButtonContent'
import { GlobalDataContext } from '../../context/context'
import { useParams } from 'react-router-dom'

// Constante para crear slugs seguros para URLs
const createSlug = (text) => {
  return text
    .replaceAll(/[^\w\s-]/g, '')
    .replaceAll(/\s+/g, '-')
    .replaceAll(/-+/g, '-')
    .toLowerCase()
    .trim()
}

const CallToAction = ({ title, subtitle, bgImages, phone, texts }) => {
  const { rpdata } = useContext(GlobalDataContext);
  const { id } = useParams();

  // Obtener los servicios en el rango 11-16 (subitems2)
  const serviciosRangoEspecifico = rpdata?.dbServices?.slice(11, 16).map(item => 
    createSlug(item.name)
  );

  // Verificar si el servicio actual está en el rango específico
  const esServicioEspecifico = id && serviciosRangoEspecifico?.includes(id);

  // Número de teléfono para servicios específicos
  const telefonoEspecifico = '540-617-3312';
  
  // Determinar qué número mostrar
  const numeroTelefono = esServicioEspecifico ? telefonoEspecifico : phone;

  return (
    <div className='flex flex-col md:flex-row items-start md:items-center mt-48 md:mt-44'>
      <div className='md:svgParrallelograBg  bgColor1 md:w-[60%] w-full h-[80px] md:h-[250px] -mr-20 md:-mr-[180px] relative z-10 flex flex-col justify-center pl-5 md:pl-20'>
        <p className='text-white font-bold'>Call Us Now</p>
        <h2 className='text-white text-[20px] md:text-[50px]'>
          <a href={`tel:+1${numeroTelefono}`}>
            {numeroTelefono}
          </a>
        </h2>
      </div>

      <div
        className=' bg-center bg-cover bg-no-repeat w-[100%] relative top-20 z-50 md:top-0 before:absolute before:bg-[#02080e67] before:w-full before:h-full svgParrallelograInverso'
        style={{
          backgroundImage: `url("${bgImages}")`
        }}
      >
        <div className={`relative text-white text-center md:text-start ${texts ? 'py-32 md:py-10' : 'py-24'} px-5 md:pl-[380px]`}>
          <p className='font-bold text-[20px]'>{subtitle}</p>
          <h2 className='pb-10 text-white'>{title}</h2>
          {
            texts ?
              <p className='text-white pb-10'>{texts}</p>
              : null
          }

          <div>
            <ButtonContent btnclases={'botonWhite'} btnStyle='three' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CallToAction